import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button, DatePicker, Input, Modal, Tooltip } from 'antd'
import users from '@services/users'
import { alertPopup } from '@utils/popup'
import moment from 'moment'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class ClosePaymentLate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            date: '',
            close_comment: '',
            requiredMsg: false
        }
    }

    openModal = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup('closePaymentLatePopup')
    }

    openEditModal = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup('editPaymentLateMessage')
    }

    onClose = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup(false)
    }

    onEditClose = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup(false)
    }

    reset = () => {
        this.setState({ date: '', close_comment: '', requiredMsg: false })
    }

    sendEdit = e => {
        e.preventDefault()
        const {
            clientInfo: { user_subscription_id, id, agent_id },
            getClientInfo
        } = this.props

        users
            .editPaymentLate({
                open_comment: e.target[0].value,
                user_subscription_id,
                client_id: id,
                agent_id
            })
            .then(() => {
                getClientInfo()
            })
            .catch(() => alertPopup({ type: 'error', title: 'אירעה שגיאה. העדכון לא בוצע', body: '' }))
            .finally(() => this.onEditClose())
    }

    submit = () => {
        const {
            clientInfo: { user_subscription_id, id },
            getClientInfo
        } = this.props
        const { date, close_comment } = this.state

        const payload = {
            user_subscription_id,
            client_id: id,
            payed_at: date || new Date(),
            close_comment
        }

        if (!close_comment) {
            this.setState({ requiredMsg: true })
        } else {
            this.setState({ requiredMsg: false })
            users
                .closePaymentLate(payload)
                .then(() => {
                    getClientInfo()
                    this.reset()
                    alertPopup({ type: 'success', title: 'עודכן בהצלחה', body: '' })
                })
                .catch(() => {
                    alertPopup({ type: 'error', title: 'עדכון נכשל', body: '' })
                })
        }
    }

    render() {
        const {
            subscription_payment_late: { open_comment, payment_late_since }
        } = this.props.clientInfo
        return (
            <>
                <div>
                    <div style={{ display: 'flex' }}>
                        <Tooltip
                            title={
                                <>
                                    <div>{moment(payment_late_since).format('DD/MM/YYYY')}</div>
                                    <div>{open_comment}</div>
                                    <span
                                        style={{ textDecoration: 'underline', cursor: 'pointer', marginRight: '15px' }}
                                        onClick={() => this.openEditModal()}
                                    >
                                        עריכה
                                    </span>
                                </>
                            }
                        >
                            <div style={{ ...style.button, ...style.buttonRight }}>
                                <span>{'קיים איחור בתשלום'}</span>
                            </div>
                        </Tooltip>

                        <div style={{ ...style.button, ...style.buttonLeft }} onClick={() => this.openModal()}>
                            <span>לסגירה</span>
                        </div>
                    </div>
                    <Modal
                        onCancel={this.onClose}
                        visible={this.props.popupStore.popupType === 'closePaymentLatePopup'}
                        title={`סגירת איחור בתשלום`}
                        footer={null}
                    >
                        <div style={{ ...style.modalContent }}>
                            <div style={{ ...style.row }}>
                                <span>{'תאריך:'}</span>
                                <DatePicker
                                    format={'DD/MM/YYYY'}
                                    defaultValue={moment(new Date(), 'DD/MM/YYYY')}
                                    onChange={e =>
                                        this.setState({
                                            date: e ? e.format('YYYY-MM-DD 00:00:00') : '',
                                            requiredMsg: false
                                        })
                                    }
                                    disabledDate={current => moment() <= current}
                                    style={{ border: 'none', width: '80%' }}
                                />
                            </div>
                            <div style={{ ...style.row }}>
                                <span>{'פירוט:'}</span>
                                <Input.TextArea
                                    style={{ width: '80%' }}
                                    value={this.state.close_comment}
                                    onChange={e => this.setState({ close_comment: e.target.value, requiredMsg: false })}
                                />
                            </div>
                            <Button
                                onClick={this.submit}
                                style={{
                                    alignSelf: 'center',
                                    marginLeft: 0
                                }}
                            >
                                {'אישור'}
                            </Button>
                            {this.state.requiredMsg && (
                                <h6
                                    style={{
                                        color: 'blue',
                                        alignSelf: 'center',
                                        marginTop: '10px'
                                    }}
                                >
                                    {'יש להזין תאריך ופירוט'}
                                </h6>
                            )}
                        </div>
                    </Modal>
                </div>
                {this.props.popupStore.popupType === 'editPaymentLateMessage' && (
                    <Modal onCancel={this.onEditClose} visible={true} title={`איחור בתשלום: עריכה`} footer={null}>
                        <form onSubmit={this.sendEdit}>
                            <Input.TextArea defaultValue={open_comment} />
                            <Button htmlType="submit">{'שמירה'}</Button>
                            <Button onClick={this.onEditClose}>{'ביטול'}</Button>
                        </form>
                    </Modal>
                )}
            </>
        )
    }
}

const style = {
    modalContent: { display: 'flex', flexDirection: 'column' },
    row: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' },
    button: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    buttonRight: { color: 'red', borderRadius: '0 4px 4px 0' },
    buttonLeft: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}

export default ClosePaymentLate
